
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./Policies.css";

const EMAIL = "joebranson23@gmail.com";

function EmailLink() {
  return <a href={`mailto:${EMAIL}`}>{EMAIL}</a>;
}

const policies = [
  {
    id: "privacy",
    title: "Privacy Policy",
    content: (
      <>
        <h3>Who we are</h3>
        <p>
          The Beth Branson Memorial Match is a fundraising event organised by
          Beth's family in her memory. This policy explains how personal
          information is handled in connection with our website and event.
        </p>
        <p>For privacy enquiries, contact <EmailLink />.</p>

        <h3>Information we collect</h3>
        <p>Depending on how you interact with us, we may process:</p>
        <ul>
          <li>Your name, email address, telephone number and ticket numbers when you purchase raffle entries.</li>
          <li>Photographs submitted to our supporter gallery, including an optional uploader name and caption.</li>
          <li>Information you provide when contacting us by email.</li>
          <li>Aggregated website visit statistics.</li>
        </ul>

        <h3>How we use information</h3>
        <p>We use information to administer raffle entries, identify and contact winners, arrange prize collection or delivery, moderate and publish supporter photographs, respond to enquiries, maintain our website and meet applicable legal obligations.</p>
        <p>We do not use raffle purchaser details to send unrelated marketing emails.</p>

        <h3>Raffle purchases and Square</h3>
        <p>
          Online raffle purchases take place through Square, an external payment
          provider. Some tickets may also be sold in person at the memorial match.
        </p>
        <p>
          BB3 Memorial does not collect or store payment card details through its
          website. We can access purchaser names, email addresses, telephone
          numbers and ticket numbers through Square to administer the raffle.
          Purchaser records are held in Square and are not separately exported
          or stored in our website's database.
        </p>

        <h3>Supporter photographs</h3>
        <p>
          Anyone may submit photographs for consideration. Providing an uploader
          name is optional, and uploader names are not displayed alongside
          approved photographs.
        </p>
        <p>
          Submissions are reviewed before publication. Rejected photograph files
          are deleted from our server. Approved photographs may be displayed
          publicly on the BB3 Memorial website.
        </p>
        <p>
          If you appear in a photograph and would like it removed, contact
          {" "}<EmailLink />.
        </p>

        <h3>Website statistics</h3>
        <p>
          Our own page-view tracker records a cumulative visit count and the
          number of visits recorded each day. The tracking route does not
          explicitly save visitor names, email addresses, IP addresses, browser
          details or unique visitor identifiers.
        </p>
        <p>
          These figures count page visits, not unique individuals. Separate
          technical server logs may be generated when operating and securing
          the website.
        </p>

        <h3>Why we process information</h3>
        <p>
          Depending on the activity, we process information where necessary to
          administer raffle participation, meet legal obligations, operate the
          event, maintain website security and respond to enquiries. Where we
          rely on consent for a particular activity, you may withdraw it by
          contacting us.
        </p>

        <h3>Sharing information</h3>
        <p>
          Information may be processed by service providers necessary to operate
          the event and website, including Square, hosting and database providers,
          email services and, where needed, prize delivery providers.
        </p>
        <p>We do not sell personal information to advertisers.</p>

        <h3>How long information is kept</h3>
        <p>
          Raffle purchaser records are held through Square in accordance with
          its applicable retention arrangements and relevant record-keeping
          requirements. Approved gallery photographs may remain published until
          removed or until the gallery is discontinued. Rejected photograph files
          are deleted from our server.
        </p>
        <p>
          Other information is retained only for as long as reasonably necessary
          for its purpose and any applicable legal obligations.
        </p>

        <h3>Your rights</h3>
        <p>
          Depending on the circumstances, you may have rights to access, correct
          or request deletion of personal information, restrict processing or
          object to certain uses. Contact <EmailLink /> to make a request.
        </p>
        <p>
          You can also raise concerns with the{" "}
          <a href="https://ico.org.uk/" target="_blank" rel="noopener noreferrer">
            Information Commissioner's Office
          </a>.
        </p>

        <h3>Changes to this policy</h3>
        <p>We may update this policy when our website, event arrangements or data-handling practices change.</p>
      </>
    ),
  },

  {
    id: "cookies",
    title: "Cookie Policy",
    content: (
      <>
        <h3>What are cookies?</h3>
        <p>
          Cookies are small files that websites can store on your device to
          support functionality, remember information or maintain login sessions.
        </p>

        <h3>Essential cookies</h3>
        <p>
          Our website uses essential functionality to support the operation and
          security of its administration area. This includes an authentication
          cookie used to maintain an authorised administrator's login session.
        </p>

        <h3>Website statistics</h3>
        <p>
          Our own page-view tracker records aggregate total and daily visit
          counts. The Express tracking route does not itself set a cookie or
          create an individual visitor identifier.
        </p>
        <p>We do not currently use Google Analytics, Microsoft Clarity or Meta Pixel.</p>

        <h3>External services</h3>
        <p>
          Our website links to external services, including Square and
          charity-related websites. These providers may use their own cookies
          when you visit their websites, and their respective policies apply.
        </p>

        <h3>Managing cookies</h3>
        <p>
          You can manage or delete cookies through your browser settings.
          Blocking essential cookies may prevent certain functionality,
          including administrator login, from working.
        </p>

        <h3>Contact</h3>
        <p>For questions about cookies or website tracking, contact <EmailLink />.</p>
      </>
    ),
  },

  {
    id: "terms",
    title: "Website Terms & Conditions",
    content: (
      <>
        <h3>About this website</h3>
        <p>
          This website provides information about the Beth Branson Memorial
          Match, an event organised by Beth's family in her memory.
        </p>

        <h3>Using the website</h3>
        <p>
          Visitors must use the website lawfully and respectfully. You must not
          interfere with the website, attempt unauthorised access, upload
          malicious material or submit unlawful content.
        </p>

        <h3>Website information</h3>
        <p>
          We aim to keep event information accurate and up to date. Timings,
          arrangements, fundraising activities and other details may change.
          We will aim to communicate important changes through the website
          or our event channels.
        </p>

        <h3>External links</h3>
        <p>
          The website contains links to external services, including Square and
          charity-related websites. These services are operated by third parties
          and have their own terms and privacy policies.
        </p>

        <h3>Raffle purchases</h3>
        <p>
          Online raffle purchases take place through Square and are subject to
          our separate Raffle Terms & Conditions.
        </p>

        <h3>Photographs and content</h3>
        <p>
          Website photographs, written content and other materials are provided
          in connection with the memorial event. Please do not copy, republish
          or commercially exploit content without permission from the relevant
          rights holder.
        </p>

        <h3>Website availability</h3>
        <p>
          We aim to keep the website available, but maintenance, technical
          issues or circumstances outside our control may occasionally affect
          access. Nothing in these terms excludes liability that cannot
          lawfully be excluded.
        </p>

        <h3>Contact</h3>
        <p>For website enquiries, contact <EmailLink />.</p>
      </>
    ),
  },

  {
    id: "raffle",
    title: "Raffle Terms & Conditions",
    content: (
      <>
        <h3>Organiser</h3>
        <p>
          The raffle is organised as part of the Beth Branson Memorial Match,
          organised by Beth's family.
        </p>

        <h3>Eligibility</h3>
        <p>Entrants must be aged 16 or over and located in Great Britain.</p>

        <h3>Purchasing tickets</h3>
        <p>
          Tickets are available through the Square payment link provided on
          the BB3 Memorial website. Additional tickets may be sold in person
          on the day of the memorial match.
        </p>

        <h3>Ticket prices</h3>
        <div className="policy-table-wrapper">
          <table className="policy-table">
            <thead>
              <tr><th>Purchase</th><th>Price</th></tr>
            </thead>
            <tbody>
              <tr><td>1 strip</td><td>£5</td></tr>
              <tr><td>2 strips</td><td>£10</td></tr>
              <tr><td>3 strips</td><td>£15</td></tr>
              <tr><td>5 strips</td><td>£20</td></tr>
              <tr><td>10 strips</td><td>£40</td></tr>
              <tr><td>20 strips</td><td>£80</td></tr>
            </tbody>
          </table>
        </div>
        <p>
          Multiple strips may be purchased. The applicable ticket numbers
          will be allocated to each purchase.
        </p>

        <h3>The draw</h3>
        <p>
          The draw takes place on the day of the memorial match and will be
          broadcast through the Facebook group linked on the BB3 Memorial
          website. 
        </p>
        <p>Entrants do not need to attend the match in person to win.</p>

        <h3>Winners</h3>
        <p>
          Winning ticket numbers will be announced during the draw. Entrants
          can check their tickets against the announced numbers.
        </p>
        <p>
          Where prizes remain unclaimed at the end of the event, the organisers
          will use available purchaser details to contact the relevant winners
          where possible.
        </p>

        <h3>Claiming prizes</h3>
        <p>
          Winners have one year from the draw date to claim their prizes.
          The organisers intend to include prizes that remain unclaimed after
          that period in the following year's raffle, subject to applicable
          raffle requirements and any conditions attached to the prize.
        </p>

        <h3>Collection and delivery</h3>
        <p>
          Winners may collect prizes by arrangement. Where a winner cannot
          collect their prize, delivery may be arranged free of charge to
          the winner.
        </p>

        <h3>Prize conditions</h3>
        <p>
          Some prizes may have donor-supplied conditions, including expiry
          dates, booking requirements or availability. Relevant conditions
          will be communicated through the prize description or to the winner.
        </p>

        <h3>Personal information</h3>
        <p>
          Purchaser information may be used to administer entries, identify
          winners and arrange collection or delivery. Please see our
          Privacy Policy for further information.
        </p>

        <h3>Contact</h3>
        <p>For raffle enquiries, contact <EmailLink />.</p>
      </>
    ),
  },

  {
    id: "photos",
    title: "Photo Upload & Media Policy",
    content: (
      <>
        <h3>Our gallery</h3>
        <p>
          The BB3 Memorial gallery celebrates Beth, the memorial match and
          the people who support the event.
        </p>

        <h3>Submitting photographs</h3>
        <p>
          Anyone may submit photographs through our supporter upload page.
          Providing an uploader name is optional, and uploader names are not
          displayed publicly alongside approved photographs.
        </p>
        <p>
          By submitting a photograph, you confirm that you have the right to
          share it and permit us to consider it for publication on the BB3
          Memorial website. Please consider the privacy of others pictured,
          particularly children, before uploading.
        </p>

        <h3>Moderation</h3>
        <p>
          All submissions are reviewed before publication. We may decline or
          remove photographs that are inappropriate, unlawful, unrelated to
          the event, infringe another person's rights or raise privacy concerns.
        </p>
        <p>
          Rejected photograph files are deleted from our server. Submission
          does not guarantee publication.
        </p>

        <h3>Permission to display photographs</h3>
        <p>
          By submitting a photograph, you give the organisers permission to
          display it on the BB3 Memorial website in connection with the
          memorial event. You retain any copyright you hold in your photograph.
          Submission does not grant permission for unrelated commercial use.
        </p>

        <h3>Requesting removal</h3>
        <p>
          If you appear in a photograph and would like it removed, contact
          {" "}<EmailLink />. Please include a link or description that helps
          us identify it. Requests will be reviewed as soon as reasonably possible.
        </p>

        <h3>Event photography</h3>
        <p>
          Photographs taken at the memorial match may be used to document and
          celebrate the event on our website. Please contact us if you have
          concerns about a particular photograph.
        </p>
      </>
    ),
  },

  {
    id: "donations",
    title: "Donation Information",
    content: (
      <>
        <h3>About our fundraising</h3>
        <p>
          The Beth Branson Memorial Match is organised by Beth's family in
          her memory to raise funds for causes associated with the event.
        </p>

        <h3>Supported charities</h3>
        <p>Funds raised support:</p>
        <ul>
          <li>St Giles Animal Rescue Centre</li>
          <li>Wooden Spoon</li>
        </ul>
        <p>
          The money available for distribution is split equally between
          the two charities.
        </p>

        <h3>How donations are handled</h3>
        <p>
          Fundraising proceeds are collected by the event organisers and
          subsequently distributed to the supported charities. Donations are
          therefore not necessarily paid directly to either charity when made.
        </p>

        <h3>Payment fees</h3>
        <p>
          Square's applicable payment-processing fees are deducted from
          payments processed through Square. The organisers do not deduct
          other event expenses from fundraising proceeds before distribution.
        </p>

        <h3>Amount raised</h3>
        <p>
          The amount-raised counter on our website displays the gross amount
          raised, before applicable Square processing fees. The final amount
          distributed may therefore differ from the displayed gross total.
        </p>

        <h3>Raffle purchases</h3>
        <p>
          Purchasing a raffle entry is separate from making a straightforward
          donation and is subject to our Raffle Terms & Conditions.
        </p>

        <h3>Contact</h3>
        <p>For fundraising enquiries, contact <EmailLink />.</p>
      </>
    ),
  },

  {
    id: "accessibility",
    title: "Accessibility Statement",
    content: (
      <>
        <h3>Our commitment</h3>
        <p>
          We want the BB3 Memorial website to be accessible and usable by as
          many people as possible. We aim to provide clear information about
          the memorial match, fundraising and ways to support the causes.
        </p>

        <h3>Using the website</h3>
        <p>
          We aim to make the website usable across different screen sizes and
          devices, with readable content and clear navigation.
        </p>

        <h3>Known accessibility issues</h3>
        <p>
          We are not currently aware of any specific parts of the website
          that visitors cannot access. However, the website has not undergone
          a comprehensive formal accessibility audit, and we do not claim
          certification against a particular accessibility standard.
        </p>

        <h3>Reporting a problem</h3>
        <p>
          If you experience difficulty using any part of the website, contact
          {" "}<EmailLink />. Please include the page or feature affected
          and, if possible, the device or browser you were using.
        </p>
        <p>
          We will review reported issues and aim to provide information in an
          alternative way where reasonably possible.
        </p>

        <h3>External services</h3>
        <p>
          External websites, including Square and charity-related services,
          are managed by their respective providers.
        </p>

        <h3>Reviewing this statement</h3>
        <p>
          We will review this statement as the website changes and
          accessibility issues are identified.
        </p>
      </>
    ),
  },
];

export default function Policies() {
  const location = useLocation();

  const getInitialPolicy = () => {
    const id = window.location.hash.replace("#", "");
    return policies.some((policy) => policy.id === id) ? id : null;
  };

  const [openPolicy, setOpenPolicy] = useState(getInitialPolicy);

  useEffect(() => {
    const id = location.hash.replace("#", "");

    if (policies.some((policy) => policy.id === id)) {
      setOpenPolicy(id);

      requestAnimationFrame(() => {
        document.getElementById(id)?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      });
    }
  }, [location.hash]);

  const togglePolicy = (id) => {
    const next = openPolicy === id ? null : id;
    setOpenPolicy(next);

    const url = `${location.pathname}${location.search}${next ? `#${next}` : ""}`;
    window.history.replaceState(null, "", url);
  };

  return (
    <main className="policies-page">
      <div className="policies-container">
        <header className="policies-header">
          <span className="policies-eyebrow">BB3 MEMORIAL</span>
          <h1>Our Policies</h1>
          <p>
            Information about the Beth Branson Memorial Match, our website,
            fundraising, raffle and supporter gallery.
          </p>
        </header>

        <div className="policies-accordion">
          {policies.map((policy) => {
            const isOpen = openPolicy === policy.id;

            return (
              <section
                className={`policy-item ${isOpen ? "open" : ""}`}
                id={policy.id}
                key={policy.id}
              >
                <h2 className="policy-heading">
                  <button
                    type="button"
                    className="policy-toggle"
                    aria-expanded={isOpen}
                    aria-controls={`policy-content-${policy.id}`}
                    onClick={() => togglePolicy(policy.id)}
                  >
                    <span>{policy.title}</span>
                    <span
                      className={`policy-chevron ${isOpen ? "rotated" : ""}`}
                      aria-hidden="true"
                    >
                      ▼
                    </span>
                  </button>
                </h2>

                {isOpen && (
                  <div
                    id={`policy-content-${policy.id}`}
                    className="policy-content"
                  >
                    {policy.content}
                  </div>
                )}
              </section>
            );
          })}
        </div>

        <div className="policies-contact">
          <h2>Have a question?</h2>
          <p>If you have any questions about our policies, please get in touch.</p>
          <a href={`mailto:${EMAIL}`}>Contact Us</a>
        </div>
      </div>
    </main>
  );
}
